import Vue from "vue";
import Router from "vue-router";



const search = r =>
  require.ensure([], () => r(require("@/views/index/search")), "search");
const center = r =>
  require.ensure([], () => r(require("@/views/center/index")), "center");

const hotellist = r =>
  require.ensure([], () => r(require("@/views/index/hotellist")), "hotellist");

const hoteldetails = r =>
  require.ensure(
    [],
    () => r(require("@/views/index/hoteldetails")),
    "hoteldetails"
  );
const booking = r =>
  require.ensure([], () => r(require("@/views/index/booking")), "booking");
const order_pay = r =>
  require.ensure([], () => r(require("@/views/booking_order/order_pay")), "order_pay");
const order_result = r =>
  require.ensure([], () => r(require("@/views/booking_order/order_result")), "order_result");

const city = r =>
  require.ensure([], () => r(require("../components/city")), "city");
const hotelorderlist = r =>
  require.ensure(
    [],
    () => r(require("@/views/center/hotelorderlist")),
    "hotelorderlist"
  );



const login = r =>
  require.ensure([], () => r(require("@/views/login/login")), "login");
  const auth_login = r =>
  require.ensure([], () => r(require("@/views/login/auth_login")), "auth_login");

const calendar = r =>
  require.ensure([], () => r(require("../components/calendar")), "calendar");


const hotelorderdetails = r =>
  require.ensure(
    [],
    () => r(require("@/views/center/hotelorderdetails")),
    "hotelorderdetails"
  );
  const gopayview = r =>
  require.ensure([], () => r(require("@/views/booking_order/test_pay")), "test_pay");

Vue.use(Router);
export default new Router({
  mode: "history",
  // base:'h5/',
  routes: [
    
    {
      path: "/",
      name: "search",
      redirect: "search",
      component: search
    },
    {
      path: "/index",
      name: "search",
      redirect: "search",
      component: search
    },
    {
      path: "/index.html",
      name: "search",
      redirect: "search",
      component: search
    },{
      path: "/order_pay",
      name: "order_pay",
      meta: {
        title: "支付页",
        navShow: false
      },
      component: order_pay
    },{
      path: "/order_result",
      name: "order_result",
      meta: {
        title: "订单完成",
        navShow: false
      },
      component: order_result
    },
    {
      path: "/index/booking",
      name: "booking",
      meta: {
        title: "提交订单",
        navShow: false
      },
      component: booking
    },
    {
      path: "/search",
      name: "search",
      component: search,
      meta: {
        keepAlive: true
      },
      children: [
        {
          path: "/index/hotellist",
          name: "hotellist",
          meta: {
            title: "酒店列表",
            navShow: false
          },
          component: hotellist
        },
        {
          path: "/index/hoteldetails",
          name: "hoteldetails",
          meta: {
            title: "酒店详情",
            navShow: false
          },
          component: hoteldetails
        },
        {
          path: "/index/city",
          name: "city",
          meta: {
            title: "选择城市",
            navShow: false
          },
          component: city
        },
        {
          path: "/index/calendar",
          name: "calendar",
          meta: {
            navShow: true
          },
          component: calendar
        }
      ]
    },
    {
      path: "/center",
      name: "center",
      component: center,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/center/hotelorderlist",
      name: "hotelorderlist",
      meta: {
        title: "酒店订单",
        navShow: false
      },
      component: hotelorderlist
    },
    {
      path: "/center/hotelorderdetails",
      name: "hotelorderdetails",
      meta: {
        title: "酒店订单",
        navShow: false
      },
      component: hotelorderdetails
    },
    {
      path: "/login",
      name: "loginpage",
      meta: {
        title: "登录",
        navShow: false
      },
      component: login
    },
    {
      path: "/auth_login",
      name: "loginpage",
      meta: {
        title: "登录",
        navShow: false
      },
      component: auth_login
    },
    {
      path: "/go_test_pay",
      name: "testpaypage",
      meta: {
        title: "支付",
        navShow: false
      },
      component: gopayview
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js